import dayjsClient from '@/lib/dayjs'

type PreviewMessageType = {
  userId: string
  content: string
  sentAt?: string
  files?: unknown[]
}

type PreviewUserType = { id: string; firstName?: string }

const MENTION_REGEX = /@([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/gi

// dernier message affiche dans la liste : mentions remplacees par le prenom, cartes de session et fichiers nommes
export function getConversationPreview(
  message: PreviewMessageType | undefined,
  users: PreviewUserType[],
  labels: { sessionRequest: string; attachment: string },
): string {
  if (!message) return ''
  if (message.content.startsWith('***session=')) return labels.sessionRequest
  const text = message.content
    .replace(MENTION_REGEX, (_, id: string) => {
      const user = users.find((u) => u.id === id)
      return user?.firstName ? `@${user.firstName}` : '@'
    })
    .replace(/\s+/g, ' ')
    .trim()
  if (!text && message.files?.length) return labels.attachment
  return text
}

// heure du dernier message : HH:mm aujourd'hui, "hier", sinon jour et mois
export function getConversationTimeLabel(date: string | undefined, labels: { yesterday: string }): string {
  if (!date) return ''
  const day = dayjsClient(date)
  if (!day.isValid()) return ''
  const now = dayjsClient()
  if (day.isSame(now, 'day')) return day.format('HH:mm')
  if (day.isSame(now.subtract(1, 'day'), 'day')) return labels.yesterday
  return day.isSame(now, 'year') ? day.format('D MMM') : day.format('D MMM YYYY')
}
